<template>
    <div class="dingdan">
        <Breadtabsheader/>
        <div class="h-piece h-mrt30 margin">
            <div class="h-formBox">
                <el-form :inline="true" :model="formInline" class="demo-form-inline h-formBorder" ref="form">
                    <div class="h-thirdColumn w-newColumn">
                        <el-form-item label="申请单编号" prop="billNo">
                            <el-input v-model="formInline.billNo" placeholder="请输入"
                                      style="width: 100%"></el-input>
                        </el-form-item>
                        <el-form-item label="发票号" prop="invoiceNumber">
                            <el-input v-model="formInline.invoiceNumber" placeholder="请输入"></el-input>
                        </el-form-item>
                        <el-form-item label="供应商" prop="supplierCode">
                            <el-input v-model="formInline.supplierCode" placeholder="请输入"
                                      style="width: 100%"></el-input>
                        </el-form-item>
                        <el-form-item label="公司主体">
                            <brselect
                                    style="width:2rem;"
                                    category="kkber_value"
                                    :v="formInline.companyCode"
                                    v-model="formInline.companyCode"
                                    clearable
                                    placeholder="--请选择--">
                            </brselect>
                        </el-form-item>
                    </div>
                    <div class="h-thirdColumn w-newColumn">
                        <el-form-item label="SRM发票状态" prop="prodtype">
                            <el-select v-model="formInline.ifCheck" :clearable="true"
                                       placeholder="请选择">
                                <el-option label="审核中" value="1"></el-option>
                                <el-option label="审核通过" value="2"></el-option>
                                <el-option label="驳回" value="3"></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="发票类型" prop="invoiceOmsType">
                          <el-select v-model="formInline.invoiceOmsType" :clearable="true"
                                     placeholder="请选择">
                            <el-option label="正常" value="1"></el-option>
                            <el-option label="退税" value="2"></el-option>
                          </el-select>
                        </el-form-item>
                    </div>
                </el-form>
                <div class="l-screenBox">
                    <div class="l-retrieval">
                        <el-button class="h-btn h-formBtn" @click="handleFilter">检索</el-button>
                        <el-button class="h-btn h-formBtn" @click="logCvp">登录商户通</el-button>
                        <el-button class="h-btn h-formBtn h-bgwhite" @click="resetData">重置</el-button>
                    </div>
                </div>
            </div>
        </div>
        <searchInvoice
                :invoiceId="id"
                :visible.sync="showSearchDialog"
                v-if="showSearchDialog"
                title="开票明细"/>
        <div class="h-table h-mrt30 tableclslist">
            <el-table
                    ref="ddtable"
                    :data="tableData"
                    @selection-change="handleSelectionChange"
                    stripe
                    border
                    :show-overflow-tooltip="true"
                    style="width: 100%"
                    max-height="450"
            >
                <el-table-column
                        type="selection"
                        fixed
                        width="40">
                </el-table-column>
                <el-table-column
                        prop="billNo"
                        label="申请单号"
                        :show-overflow-tooltip="true"
                        width="150">
                </el-table-column>
                <el-table-column
                        prop="invoiceNumber"
                        label="发票号"
                        :show-overflow-tooltip="true"
                        width="150">
                </el-table-column>
                <el-table-column
                        prop="supplierCode"
                        label="供应商编码"
                        :show-overflow-tooltip="true"
                        width="150">
                </el-table-column>
                <el-table-column
                        prop="supplierName"
                        label="供应商名称"
                        :show-overflow-tooltip="true"
                        width="150">
                </el-table-column>
                <el-table-column
                        prop="companyCode"
                        label="开票公司"
                        width="180"
                        :show-overflow-tooltip="true">
                    <template slot-scope="scope">
                        <dictname category="kkber_value"  :v="scope.row.companyCode"/>
                    </template>
                </el-table-column>
                <el-table-column
                    prop="invoiceOmsType"
                    label="发票类型"
                    :show-overflow-tooltip="true"
                    width="110">
                  <template scope="scope">
                    <span v-if="scope.row.invoiceOmsType == '1'">正常</span>
                    <span v-if="scope.row.invoiceOmsType == '2'">退税</span>
                  </template>
                </el-table-column>
                <el-table-column
                        prop="ifCheck"
                        label="SRM发票状态"
                        :show-overflow-tooltip="true"
                        width="110">
                    <template scope="scope">
                        <span v-if="scope.row.ifCheck == '1'">审核中</span>
                        <span v-if="scope.row.ifCheck == '2'">审核通过</span>
                        <span v-if="scope.row.ifCheck == '3'">驳回</span>
                    </template>
                </el-table-column>
                <el-table-column
                        prop="shuilv"
                        label="税率"
                        :show-overflow-tooltip="true"
                        width="80">
                </el-table-column>
                <el-table-column
                        prop="currency"
                        label="币种"
                        :show-overflow-tooltip="true"
                        width="90">
                </el-table-column>
                <el-table-column
                        prop="noTaxAmount"
                        label="不含税金额"
                        :show-overflow-tooltip="true"
                        width="120">
                </el-table-column>
                <el-table-column
                        prop="includeTaxAmount"
                        label="价税合计"
                        :show-overflow-tooltip="true"
                        width="120">
                </el-table-column>
                <el-table-column
                        prop="invoiceDate"
                        label="开票日期"
                        :show-overflow-tooltip="true"
                        width="150">
                </el-table-column>
                <el-table-column
                        prop="createTime"
                        label="发票创建日期"
                        :formatter="formatDate"
                        :show-overflow-tooltip="true"
                        width="150">
                </el-table-column>

                <el-table-column
                        fixed="right"
                        label="操作"
                        width="100"
                >
                    <template slot-scope="scope">
                        <div style="text-align: left;">
                            <el-button
                                    type="text"
                                    size="small"
                                    @click="getDetail(scope.row.id)"
                                    class="h-tableLink h-btn">
                                查看
                            </el-button>
                            <el-button
                                v-if="scope.row.fileUrl != null && scope.row.fileUrl != ''"
                                type="text"
                                size="small"
                                @click="getInvoiceFile(scope.row)"
                                class="h-tableLink h-btn">
                              发票
                            </el-button>
                        </div>
                    </template>
                </el-table-column>
            </el-table>

            <el-dialog  title="发票预览"
                        :visible="invoicePreviewDialog"
                        @close="closePreviewDialog"
                        width="1300px"
                        class="bio-dialog">
                <table style=" border-bottom: none;" >
                    <tr>
                        <td style="width: 300px"></td>
                        <td style="width: 600px;text-align: center" class="invoice-preview-front">
                            <h1>{{invoicePreviewData.header.inherentLabel.einvoiceType.labelName}}（{{invoicePreviewData.header.inherentLabel.generalOrSpecialVAT.labelName}}）</h1>
                            <p class="un_line"></p>
                            <p style="opacity: 0;">——————————————————————</p>
                        </td>
                        <td style="width: 300px;">
                            <div>
                                <span class="invoice-preview-front">发票号码：</span>
                                <span>{{invoicePreviewData.taxSupervisionInfo.invoiceNumber}}</span>
                            </div>
                            <br>
                            <div>
                                <span class="invoice-preview-front">发票日期：</span>
                                <span>{{invoicePreviewData.taxSupervisionInfo.issueTime}}</span>
                            </div>
                        </td>
                    </tr>
                </table>
                <table class="invoice-preview-table" >
                    <tr>
                        <!--        表格第二行，购买方信息，发票抬头，销售方信息等等-->
                        <td style="border-right: 2px solid #602121;width: 20px" class="invoice-preview-front">购买方信息</td>
                        <td >
                            <span class="invoice-preview-front">名称：</span>
                            <span>{{invoicePreviewData.einvoiceData.buyerInformation.buyerName}}</span>
                            <br>
                            <br>
                            <br>
                            <span class="invoice-preview-front">统一社会信用代码/纳税人识别号：</span>
                            <span>{{invoicePreviewData.einvoiceData.buyerInformation.buyerIdNum}}</span>
                        </td>
                        <td style="border-right: 2px solid #602121;border-left: 2px solid #602121;width: 20px" class="invoice-preview-front">销售方信息</td>
                        <td >
                            <span class="invoice-preview-front">名称：</span>
                            <span>{{invoicePreviewData.einvoiceData.sellerInformation.sellerName}}</span>
                            <br>
                            <br>
                            <br>
                            <span class="invoice-preview-front">统一社会信用代码/纳税人识别号：</span>
                            <span>{{invoicePreviewData.einvoiceData.sellerInformation.sellerIdNum}}</span>
                        </td>
                    </tr>
                </table>
                <!-- 第二个表格，费用详细信息，项目名称，单位，数量，单价，金额等等-->
                <table class="invoice-preview-table">
                    <tr class="invoice-preview-front">
                        <!--        表格第三行，费用详细信息，项目名称，单位，数量，单价，金额等等，是一个表内表格-->
                        <td style="width: 300px;padding-left:40px;">项目名称</td>
                        <td style="width: 300px">规格型号</td>
                        <td style="width: 125px">单   位</td>
                        <td style="width: 125px">数   量</td>
                        <td style="width: 125px">单   价</td>
                        <td style="width: 125px">金   额</td>
                        <td style="width: 125px">税率/征收率</td>
                        <td style="width: 125px">税   额</td>
                    </tr>
                    <!--    fixme   循环这个td，做数据表示-->
                    <tr  v-for="(item, index) in invoicePreviewData.einvoiceData.issuItemInformationList" :key="index" style="width: 1200px">
                        <!--        表格第三行，费用详细信息，项目名称，单位，数量，单价，金额等等，是一个表内表格-->
                        <td style="width: 300px;word-wrap:break-word;">{{item.itemName}}</td>
                        <td style="width: 300px;word-wrap:break-word;">{{item.specMod}}</td>
                        <td style="width: 125px">{{item.meaUnits}}</td>
                        <td style="width: 125px">{{item.quantity}}</td>
                        <td style="width: 125px">{{item.unPrice}}</td>
                        <td style="width: 125px">{{item.amount}}</td>
                        <td style="width: 125px">{{item.taxRate*100}}%</td>
                        <td style="width: 125px">{{item.comTaxAm}}</td>
                    </tr>
                    <tr style="height: 200px;"></tr>
                    <tr>
                        <td style="width: 300px;padding-left:80px;word-wrap:break-word;" class="invoice-preview-front">合   计</td>
                        <td style="width: 300px;word-wrap:break-word;"></td>
                        <td style="width: 125px"></td>
                        <td style="width: 125px"></td>
                        <td style="width: 125px"></td>
                        <td style="width: 125px">{{invoicePreviewData.einvoiceData.basicInformation.totalAmWithoutTax}}</td>
                        <td style="width: 125px"></td>
                        <td style="width: 125px">{{invoicePreviewData.einvoiceData.basicInformation.totalTaxAm}}</td>
                    </tr>
                </table>
                <table class="invoice-preview-table" style="">
                    <tr>
                        <td style="width: 300px;padding-left:40px;border-right: 2px solid;" class="invoice-preview-front">价税合计（大写）</td>
                        <td style="width: 900px">
                            <p style="width: 600px;display: inline-block;">⊗ {{invoicePreviewData.einvoiceData
                                .basicInformation.totalTaxIncludedAmountInChinese}}</p>
                            <p style="display: inline-block">（小写）￥{{invoicePreviewData.einvoiceData
                                .basicInformation.totalTaxIncludedAmount}}</p>
                        </td>
                    </tr>
                </table>
                <table class="invoice-preview-table" style="height: 100px">
                    <tr>
                        <td style="width: 20px;border-right: 2px solid;" class="invoice-preview-front">备注</td>
                        <td>{{invoicePreviewData.einvoiceData
                            .additionalInformation.remark}}</td>
                    </tr>
                </table>
                <div style="padding-left: 40px;padding-top: 10px" >
                    <span class="invoice-preview-front" >开票人： </span>
                    <span>{{invoicePreviewData.einvoiceData
      .basicInformation.drawer}}</span>
                </div>
            </el-dialog>


            <div style="display:flex;justify-content: space-between;flex-direction:row-reverse;margin-top:20px">
                <pagination :page="formInline" @query="query"/>
              <div style="display:flex;align-items: center;">
                <el-button class="h-btn h-formBtn h-bgblueQ" icon="h-el-icon h-el-icon-import"
                           @click="exportExcel">批量导出
                </el-button>
              </div>
            </div>
        </div>
    </div>
</template>
<script>
    import ss from '../../api/SystemService'
    import searchInvoice from './searchInvoice'
    import updownfile from "../../utils/updownfile";
    export default {
        components: {
            searchInvoice
        },
        data() {
            return {
                formInline:{
                    billNo:null,
                    supplierCode:null,
                    invoiceNumber:null,
                    companyCode:null,
                    invoiceOmsType:null,
                    ifCheck:'',
                    pageSize: 10,
                    pageNo: 1,
                    total: 0,
                },
                invoicePreviewData: {
                    header: {
                        inherentLabel: {
                            einvoiceType: {
                                labelName: ''
                            },
                            generalOrSpecialVAT: {
                                labelName: ''
                            }
                        }
                    },
                    einvoiceData: {
                        sellerInformation: {
                            sellerIdNum: '',
                            sellerName: ''
                        },
                        buyerInformation: {
                            buyerIdNum: '',
                            buyerName: ''
                        },
                        basicInformation: {
                            totalAmWithoutTax: '',
                            totalTaxAm: '',
                            totalTaxIncludedAmount: '',
                            totalTaxIncludedAmountInChinese: '',
                            drawer: ''
                        },
                        issuItemInformationList: [
                            {
                                itemName: '',
                                specMod: '',
                                meaUnits: '',
                                quantity: '',
                                unPrice: '',
                                amount: '',
                                taxRate: '',
                                comTaxAm: '',
                                totalTaxIncludedAmount: '',
                                taxClassificationCode: ''
                            }
                        ],
                        additionalInformation: {
                            remark: ''
                        }
                    },
                    taxSupervisionInfo: {
                        invoiceNumber: '',
                        issueTime: ''
                    }
                },
                tableData: [],
                tableSelectedList: [],
                showSearchDialog:false,
                invoicePreviewDialog:false,
                id:null,
            }
        },

        created() {
            this.query();

        },

        methods: {
            //重置
            resetData() {
                this.formInline.supplierCode= "";
                this.formInline.companyCode="";
                this.formInline.billNo = null;
                this.formInline.invoiceNumber = null;
                this.formInline.ifCheck = '';
                this.formInline.invoiceOmsType = null;
                this.query();
            },
            //检索
            handleFilter() {
                this.query();
            },
            query() {
                var data = this.formInline;
                ss.invoiceApplyList.selectNewPage(data).then(rd => {
                    this.tableData = rd.records;
                    this.formInline.total = rd.total
                });
            },
            handleSelectionChange(lists) {
                this.tableSelectedList = lists;
            },
            //查询
            getDetail(id){
                this.id = id;
                this.showSearchDialog = true;
            },
            //查询
            getInvoiceFile(query){
              ss.invoiceApplyList.selectInvoiceFile(query).then(rd => {
                for(var i=0;i<rd.msg.length;i++){
                    //看看是不是xml文件
                    console.log(rd.msg[i].fileUrl)
                    if(rd.msg[i].fileUrl.includes("xml")){
                        //解析xml
                        ss.invoiceApplyList.getEinvoiceByXmlFile(rd.msg[i].fileUrl).then(rd => {
                            if(rd.f){
                                this.invoicePreviewData = rd.msg;
                                this.invoicePreviewDialog = true;
                            }else {
                                this.$message({
                                    type: 'error',
                                    message: '发票解析错误!'
                                })
                            }
                        });
                    }else {
                        window.open( rd.msg[i].fileUrl, '_blank')
                    }
                }
              });
            },
            exportExcel(){
              var idlist=[];
              this.tableSelectedList.forEach(element => {
                idlist.push(element.id);
              });
              if (idlist) {
                this.formInline.ids = idlist.join(",");
              } else {
                this.formInline.ids ='';
              }
              var q = this.formInline;
              updownfile.down("/api/swyl/v1/demo/bscInvoiceSrm/downloadExcel",q,"get",'params');
            },
            //登录商户通
            logCvp(){
              var pageCode = "SWYL_BILL_BZ";
              var billCode =""
              ss.LoginService.getLogCvp(pageCode,billCode).then(rd => {
                console.log("rd",rd)
                if(rd.f){
                  window.open(rd.msg, '_blank')
                }
              })
            },
            formatDate(row, column) {
                // 获取单元格数据
                let data = row[column.property]
                if(data == null || data == '') {
                    return null
                }
                let dt = new Date(data)
                return this.$util.riQi3(dt);
            },
            closePreviewDialog(){
                this.invoicePreviewDialog = false;
            }
        }

    }
</script>
<style>
    .container {
        display: inline-grid;
        grid-template-columns: 1fr 1fr 1fr;
    }
    .box {
        border: 1px solid;
        width: 30px;
        height: 30px;
        line-height: 30px;
        text-align: center;
    }
    .un_line{
        width:95%; height:5px;
        border-top:2px solid;
        border-bottom:2px solid;
        text-align: center;
    }
    .invoice-preview-table{
        margin: auto;
        border-collapse: collapse;
        border-spacing: 0 0px;
        width: 1200px;
        border-bottom: none;
        border: 2px solid #602121;
        cellpadding:0;
        margin-top: -2px;
    }
    .invoice-preview-front{
        color: #602121;
    }
</style>
